import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "answer-result-detail d-flex justify-content-center flex-wrap"
}
const _hoisted_2 = {
  key: 1,
  class: "exam-result-layout"
}
const _hoisted_3 = {
  key: 0,
  class: "w-100 h-100"
}
const _hoisted_4 = { class: "exam-result-main" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "title w-100 mt-0 text-center" }
const _hoisted_7 = { class: "question-body" }
const _hoisted_8 = { class: "flex-wrap d-flex result-title w-full" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "d-flex justify-center align-center w-100" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "sidebar-content" }
const _hoisted_14 = {
  key: 2,
  style: {"padding-right":"40px"}
}
const _hoisted_15 = { class: "question-list-wrapper" }
const _hoisted_16 = {
  key: 2,
  class: "answer-result-detail-mobile w-100"
}
const _hoisted_17 = {
  key: 0,
  class: "w-100"
}
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "green-bgr d-flex align-center justify-space-between p-2" }
const _hoisted_20 = { class: "mobile-result-header white-text" }
const _hoisted_21 = { class: "footer-mobile-nav green-bgr d-flex justify-center align-center p-2" }

import { ref, computed, watch, onMounted, onBeforeUnmount, nextTick, getCurrentInstance } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { checkMobile, getPassAnswer } from '../../utils/utils'
import ChartProgress from '../atoms_molecules/ChartProgress.vue'
import ExamResultQuestionGroupList from '../atoms_molecules/ExamResultQuestionGroupList.vue'
import { ROUTER_NAME } from '../../router'
import SlideBar from '../atoms_molecules/SlideBar.vue'
import { filter, find, map } from 'lodash'
import Question from '../../models/question'
import { LETTER_FORMAT } from '../../utils/constants'
import { ExamResultQuestion, GroupQuestion } from '../../../api/v2/models/question'
import ExamResultQuestionBodyWeb from '../atoms_molecules/ExamResultQuestionBodyWeb.vue'
import ExamResultQuestionBodyMobile from '../atoms_molecules/ExamResultQuestionBodyMobile.vue'
import { FooterData, ButtomItemData, footerState } from '../../stores/footer'
import hotkeys from 'hotkeys-js'
import { headerState } from '../../stores/header'
import api from '../../../api/v2/api'
import Banner from '../../../api/v2/models/banner'
import { userState } from '../../stores/user'
import { examResultState } from '../../stores/exam_result'
import Exam from '../../models/exam'
import MesageContainer from "../organisms/MesageContainer.vue"
import ThreadContainer from "../organisms/ThreadContainer.vue"
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import { getQueryString } from '../../../../helpers/route-helper'
import { getLastExamRoute } from '../../utils/setup_exam_router'
import ExamGoalReturnButton from '../atoms_molecules/ExamGoalReturnButton.vue'

const PANE_SIZE_STORAGE_KEY = 'exam_result_main_left_pane_size'

// Refs

export default /*@__PURE__*/_defineComponent({
  __name: 'ExamResultMain',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const instance = getCurrentInstance()
const $t = instance?.proxy?.$t || ((key: string) => key)

// Constants
const mesageContainer = ref<InstanceType<typeof MesageContainer> | null>(null)
const rightSideBar = ref(null)
const rightSideBarCard = ref(null)

// Reactive Data
const isShowBody = ref(true)
const mobile = ref(checkMobile())
const tabSelected = ref<number | null>(null)
const totalPass = ref(0)
const reRender = ref(Date().toString())
const banners = ref<Banner[]>([])
const currentGroupQuestion = ref<GroupQuestion | null>(null)
const leftPaneSize = ref((() => {
  const saved = localStorage.getItem(PANE_SIZE_STORAGE_KEY)
  return saved ? parseFloat(saved) : 75
})())
const footerMobile = ref<FooterData>({
  color: '#7DD420',
  show: true,
  default: {
    show: false
  },
  buttons: {
    show: true,
    items: []
  }
})
const questionNumber = ref(0)
const tab = ref<number | null>(null)
const mobileSwipeIndex = ref(1)

// Computed
const schoolSetting = computed(() => headerState.schoolSetting)
const exam = computed(() => examResultState.examResult)
const user = computed(() => userState.user)
const questionId = computed(() => Number(route.params.questionId))
const examQScoreHistory = computed(() => examResultState.examQScoreHistory)
const isEmbed = computed(() => !!route.meta?.embed)

const userExam = computed(() => {
  if (userExamId.value) {
    return exam.value?.userExams.find((ue) => `${ue.id}` === userExamId.value)
  }
  return exam.value?.userExam
})

const redirectNotFoundPage = computed(() => examResultState.redirectNotFoundPage)
const userExamId = computed(() => getQueryString(route.query, 'user_exam_id'))
const groupQuestions = computed(() => examResultState.groupQuestions)
const examResultQuestions = computed(() => examResultState.examResultQuestions)
const currentGroup = computed<GroupQuestion | null>(() => examResultState.currentGroupQuestion)

const currentQuestion = computed<ExamResultQuestion | undefined>(() => 
  examResultQuestions.value.find((item) => item.id === parseInt(route.params.questionId as string))
)

const maxScore = computed(() => currentGroup.value?.maxScore || 0)
const score = computed(() => currentGroup.value?.getScoreByUserExam(userExam.value!) || 0)
const isPass = computed(() => score.value === maxScore.value)
const isNotFullScore = computed(() => score.value < maxScore.value && score.value > 0)
const isNotPass = computed(() => score.value === 0)

const currentIndex = computed(() => {
  if (!currentGroup.value) {
    return -1
  }
  const notDescriptionGroups = groupQuestions.value.filter((item) => !item.isDescriptionQuestion)
  return notDescriptionGroups.map(e => e.groupId).indexOf(currentGroup.value.groupId) + 1
})

const sortedgroupQuestions = computed(() => 
  [...groupQuestions.value].sort((a, b) => a.groupId - b.groupId)
)

const isLastItem = computed(() => {
  const groupIndex = groupQuestions.value.indexOf(currentGroupQuestion.value!)
  return groupIndex === groupQuestions.value.length - 1
})

const isFirstItem = computed(() => {
  const groupIndex = groupQuestions.value.indexOf(currentGroupQuestion.value!)
  return groupIndex === 0
})

// Functions
function getQuestionNumber(groupExamResultQuestion: GroupQuestion): number {
  return (
    groupQuestions.value
      .filter((item) => item.questions.every((question) => !question.isDescriptionQuestion))
      .indexOf(groupExamResultQuestion) + 1
  )
}

function onPaneResized(event: any) {
  const panes = event.panes || event
  if (Array.isArray(panes) && panes.length > 0) {
    leftPaneSize.value = panes[0].size
    localStorage.setItem(PANE_SIZE_STORAGE_KEY, String(leftPaneSize.value))
  }
}

function redirectToNotFoundPage() {
  router.push({
    name: ROUTER_NAME.NOT_FOUND
  })
}

function updateData(examData: Exam | null, routeData: any) {
  tabSelected.value = parseInt(routeData.params.questionId)
  if (examData && examResultQuestions.value && examResultQuestions.value.length) {
    if (!currentQuestion.value) {
      redirectToNotFoundPage()
    }
    const question = find(examResultQuestions.value, ['id', parseInt(routeData.params.questionId)])
    if (question) {
      totalPass.value = getPassAnswer(question.answerItems)
      const passAnswers = filter(userExam.value?.answers || [], {
        qId: parseInt(routeData.params.questionId),
        correct: true
      })
    }
    if (mobile.value) {
      footerMobile.value.buttons.items = getFooterItems(examData.questions.length)
      footerState.setFooter(footerMobile.value as FooterData)
    }
  }
}

function getFooterItems(count: number): ButtomItemData[] {
  return [
    {
      icon: 'mdi-chevron-double-left',
      round: false,
      color: 'white',
      action: first,
      disabled: isFirstItem.value
    },
    {
      icon: 'mdi-chevron-left',
      round: false,
      color: 'white',
      action: previous,
      disabled: isFirstItem.value
    },
    {
      icon: '',
      round: false,
      spacer: true,
      color: '',
      label: ''
    },
    {
      icon: 'mdi-chevron-right',
      round: false,
      color: 'white',
      action: next,
      disabled: isLastItem.value
    },
    {
      icon: 'mdi-chevron-double-right',
      round: false,
      color: 'white',
      action: last,
      disabled: isLastItem.value
    }
  ]
}

function getBanner(position: string): Banner | undefined {
  return banners.value.find(banner => banner.position === position)
}

function settupHotKeys() {
  removeHotkeys()

  hotkeys.filter = (event) => {
    return true
  }

  hotkeys('ctrl+shift+right, control+shift+right, option+right', 'exams', () => {
    next()
  })

  hotkeys('alt+shift+right', 'exams', () => {
    last()
  })

  hotkeys('ctrl+shift+left, control+shift+left, option+left', 'exams', () => {
    return previous()
  })

  hotkeys('alt+shift+left', 'exams', () => {
    first()
  })

  hotkeys.setScope('exams')
}

function removeHotkeys() {
  hotkeys.deleteScope('exams')
}

function backToExamResult() {
  const found = getLastExamRoute()
  if (found) {
    router.push(found)
  } else {
    router.push({
      name: ROUTER_NAME.EXAM_RESULT,
      params: {
        examId: route.params.examId as string
      },
      query: route.query
    })
  }
}

function getSkillsName(skills: any[]) {
  return map(skills, 'name').join(', ')
}

function next() {
  if (isLastItem.value) {
    return
  }
  const groupIndex = groupQuestions.value.map(function (e) {
    return e.groupId
  }).indexOf(currentGroup.value!.groupId)
  
  if (groupQuestions.value[groupIndex + 1]) {
    goQuestion(groupQuestions.value[groupIndex + 1].questions[0])
  }
}

function previous() {
  if (isFirstItem.value) {
    return
  }
  const groupIndex = groupQuestions.value.map(function (e) {
    return e.groupId
  }).indexOf(currentGroup.value!.groupId)
  
  if (groupQuestions.value[groupIndex - 1]) {
    goQuestion(groupQuestions.value[groupIndex - 1].questions[0])
  }
}

function first() {
  goQuestion(groupQuestions.value[0].questions[0])
}

function last() {
  goQuestion(groupQuestions.value[groupQuestions.value.length - 1].questions[0])
}

function goQuestion(question: Question) {
  if (question.id !== currentQuestion.value?.id) {
    router.push({
      name: ROUTER_NAME.ANSWER_RESULT_DETAIL,
      params: {
        examId: `${exam.value!.id}`,
        questionId: `${question.id}`
      },
      query: route.query
    })
  }
}

function back() {
  router.push({
    name: ROUTER_NAME.EXAM_RESULT,
    params: {
      examId: route.params.examId as string
    },
    query: route.query
  })
}

function toResulQuestionLList() {
  router.push({
    name: ROUTER_NAME.EXAM_RESULT_QUESTION_LIST,
    params: {
      examId: route.params.examId as string
    },
    query: route.query
  })
}

function handleSwipeLeft() {
  if (!isLastItem.value) {
    next()
  }
  nextTick(() => {
    mobileSwipeIndex.value = 1
  })
}

function handleSwipeRight() {
  if (!isFirstItem.value) {
    previous()
  }
  nextTick(() => {
    mobileSwipeIndex.value = 1
  })
}

function updateParentTab(value: number) {
  tab.value = value
}

function emitCreateThread(value: number) {
  if (typeof value === 'number') {
    tab.value = value
  }
  mesageContainer.value?.createThread()
}

// Watchers
watch([exam, examResultQuestions], () => {
  updateData(exam.value, route)
})

watch(() => route, (val) => {
  isShowBody.value = false
  setTimeout(() => {
    isShowBody.value = true
    window.scrollTo(0, 0)
  }, 100)

  if (mobile.value) {
    const date = new Date()
    reRender.value = date.getTime().toString()
  }
  updateData(exam.value, val)
}, { immediate: true, deep: true })

watch(redirectNotFoundPage, (val) => {
  if (val) {
    examResultState.setRedirectNotFoundPage({ status: false })
    redirectToNotFoundPage()
  }
})

watch(questionId, async () => {
  await examResultState.requestExamGroupQuestion(Number(route.params.questionId))
  currentGroupQuestion.value = examResultState.groupQuestions.find((item) => item.groupId === examResultState.currentGroupQuestion?.groupId) || null
})

// Lifecycle
onMounted(() => {
  if (exam.value) {
    updateData(exam.value, route)
  }
  examResultState.requestExamResult(parseInt(route.params.examId as string)).then(() => {
    examResultState.setUserExamId(Number(userExamId.value))
    examResultState.getExamResultQuestions()
    examResultState.requestExamGroupQuestion(Number(route.params.questionId))
    examResultState.requestExamQScoreHistories(parseInt(route.params.examId as string))
  })

  if (examResultState.currentGroupQuestion) {
    currentGroupQuestion.value = examResultState.groupQuestions.find((item) => item.groupId === examResultState.currentGroupQuestion?.groupId) || null
  }
  
  tabSelected.value = parseInt(route.params.questionId as string)
  headerState.setTitle($t('common.answer', { format: LETTER_FORMAT.UPTITLECASE }) as string)
  settupHotKeys()
})

onBeforeUnmount(() => {
  removeHotkeys()
})

// Created logic (runs immediately)
;(async () => {
  try {
    banners.value = await Promise.resolve(api.banner.index({ type: "question_result" }))
  } catch (e) {
  }
})()

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", {
    key: reRender.value,
    class: "answer-result-detail-main"
  }, [
    (exam.value && !userExam.value?.finishedAt)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_alert, { type: "warning" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)('exam_result.warning_finish_exam', {format: _unref(LETTER_FORMAT).UPTITLECASE})), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]))
      : (!mobile.value && exam.value && userExam.value?.finishedAt)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (exam.value && currentGroup.value && exam.value.questions)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_unref(Splitpanes), {
                    class: "default-theme",
                    onResized: onPaneResized
                  }, {
                    default: _withCtx(() => [
                      _createCommentVNode(" Main Content (Left) - Scrolls inside pane "),
                      _createVNode(_unref(Pane), {
                        size: leftPaneSize.value,
                        "min-size": 50,
                        "max-size": 85,
                        class: "exam-result-main-pane"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            (getBanner('question_result_top'))
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "banner",
                                  innerHTML: getBanner('question_result_top')?.bodyHtml
                                }, null, 8 /* PROPS */, _hoisted_5))
                              : _createCommentVNode("v-if", true),
                            _createVNode(_component_v_card, { class: "p-0 question-content-card" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "green-bgr white-text px-0" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      variant: "text",
                                      class: "ps-0 ms-1 white-text",
                                      onClick: backToExamResult
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { start: "" }, {
                                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                            _createTextVNode("mdi-chevron-left", -1 /* CACHED */)
                                          ]))]),
                                          _: 1 /* STABLE */
                                        }),
                                        _cache[5] || (_cache[5] = _createElementVNode("span", null, "戻る", -1 /* CACHED */))
                                      ]),
                                      _: 1 /* STABLE */
                                    }),
                                    _createVNode(ExamGoalReturnButton, {
                                      class: "ms-2",
                                      "exam-id": _unref(route).params.examId as string,
                                      color: "white",
                                      variant: "flat"
                                    }, null, 8 /* PROPS */, ["exam-id"]),
                                    _createElementVNode("div", _hoisted_6, _toDisplayString(currentGroup.value.isDescriptionQuestion
                          ? _unref($t)('exam_result.description', {format: _unref(LETTER_FORMAT).UPTITLECASE})
                          : `${currentIndex.value} ${_unref($t)('exam_result.problem', {format: _unref(LETTER_FORMAT).UPTITLECASE})}`), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createElementVNode("div", _hoisted_7, [
                                  _createElementVNode("div", _hoisted_8, [
                                    (currentGroup.value.isWorkSheet)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                          _createVNode(_component_v_chip, {
                                            class: "m-2",
                                            color: "orange",
                                            "text-color": "white"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_unref($t)('question.work_sheet')) + " ", 1 /* TEXT */),
                                              _createVNode(_component_v_icon, { end: "" }, {
                                                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                                  _createTextVNode("mdi-star", -1 /* CACHED */)
                                                ]))]),
                                                _: 1 /* STABLE */
                                              })
                                            ]),
                                            _: 1 /* STABLE */
                                          })
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    (isShowBody.value && currentGroup.value)
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(currentGroup.value.questions, (item, index) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                            _createVNode(ExamResultQuestionBodyWeb, {
                                              id: `question_${item.id}`,
                                              groupIndex: currentIndex.value,
                                              currentQuestion: item,
                                              index: index + 1,
                                              isMultipleQuestion: currentGroup.value.questions.length > 1,
                                              schoolSetting: schoolSetting.value,
                                              examQScoreHistory: examQScoreHistory.value,
                                              exam: exam.value,
                                              "user-exam": userExam.value
                                            }, null, 8 /* PROPS */, ["id", "groupIndex", "currentQuestion", "index", "isMultipleQuestion", "schoolSetting", "examQScoreHistory", "exam", "user-exam"]),
                                            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "divider" }, null, -1 /* CACHED */))
                                          ], 64 /* STABLE_FRAGMENT */))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      : _createCommentVNode("v-if", true),
                                    (getBanner('question_result_bottom'))
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 2,
                                          class: "banner",
                                          innerHTML: getBanner('question_result_bottom')?.bodyHtml
                                        }, null, 8 /* PROPS */, _hoisted_10))
                                      : _createCommentVNode("v-if", true)
                                  ])
                                ]),
                                _createVNode(_component_v_card_actions, { class: "footer-card-question p-3" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_11, [
                                      _createVNode(_component_v_btn, {
                                        variant: "text",
                                        class: "m-1 nav-btn",
                                        onClick: first,
                                        disabled: isFirstItem.value
                                      }, {
                                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                          _createTextVNode(" 最初 ", -1 /* CACHED */)
                                        ]))]),
                                        _: 1 /* STABLE */
                                      }, 8 /* PROPS */, ["disabled"]),
                                      _createVNode(_component_v_btn, {
                                        variant: "text",
                                        class: "m-1 nav-btn",
                                        onClick: previous,
                                        disabled: isFirstItem.value
                                      }, {
                                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                          _createTextVNode(" 前へ ", -1 /* CACHED */)
                                        ]))]),
                                        _: 1 /* STABLE */
                                      }, 8 /* PROPS */, ["disabled"]),
                                      _createVNode(_component_v_spacer),
                                      _createVNode(_component_v_btn, {
                                        variant: "text",
                                        class: "m-1 nav-btn",
                                        onClick: next,
                                        disabled: isLastItem.value
                                      }, {
                                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                          _createTextVNode(" 次へ ", -1 /* CACHED */)
                                        ]))]),
                                        _: 1 /* STABLE */
                                      }, 8 /* PROPS */, ["disabled"]),
                                      _createVNode(_component_v_btn, {
                                        variant: "text",
                                        class: "m-1 nav-btn",
                                        onClick: last,
                                        disabled: isLastItem.value
                                      }, {
                                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                          _createTextVNode(" 最後 ", -1 /* CACHED */)
                                        ]))]),
                                        _: 1 /* STABLE */
                                      }, 8 /* PROPS */, ["disabled"])
                                    ])
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }),
                            (getBanner('question_result_bottom'))
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "banner",
                                  innerHTML: getBanner('question_result_bottom')?.bodyHtml
                                }, null, 8 /* PROPS */, _hoisted_12))
                              : _createCommentVNode("v-if", true)
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["size"]),
                      _createCommentVNode(" Sidebar (Right) - Fixed, scrolls inside "),
                      _createVNode(_unref(Pane), {
                        size: 100 - leftPaneSize.value,
                        "min-size": 15,
                        "max-size": 50,
                        class: "exam-result-sidebar-pane",
                        ref_key: "rightSideBar",
                        ref: rightSideBar
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            class: "p-0 sidebar-card",
                            ref_key: "rightSideBarCard",
                            ref: rightSideBarCard
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_v_tabs, {
                                  modelValue: tab.value,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_tab, { key: "question" }, {
                                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                        _createTextVNode("Questions", -1 /* CACHED */)
                                      ]))]),
                                      _: 1 /* STABLE */
                                    }),
                                    (schoolSetting.value && schoolSetting.value.useAiChatExam)
                                      ? (_openBlock(), _createBlock(_component_v_tab, { key: "chat" }, {
                                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                            _createTextVNode("チャット", -1 /* CACHED */)
                                          ]))]),
                                          _: 1 /* STABLE */
                                        }))
                                      : _createCommentVNode("v-if", true),
                                    (schoolSetting.value && schoolSetting.value.useAiChatExam)
                                      ? (_openBlock(), _createBlock(_component_v_tab, { key: "thread" }, {
                                          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                            _createTextVNode("スレッド", -1 /* CACHED */)
                                          ]))]),
                                          _: 1 /* STABLE */
                                        }))
                                      : _createCommentVNode("v-if", true),
                                    (schoolSetting.value && schoolSetting.value.useAiChatExam)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                                      : _createCommentVNode("v-if", true),
                                    (schoolSetting.value && schoolSetting.value.useAiChatExam)
                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                          key: 3,
                                          class: "btn-new-chat",
                                          icon: "",
                                          onClick: _cache[0] || (_cache[0] = ($event: any) => (emitCreateThread(1)))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, null, {
                                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                                _createTextVNode("mdi-comment-plus", -1 /* CACHED */)
                                              ]))]),
                                              _: 1 /* STABLE */
                                            })
                                          ]),
                                          _: 1 /* STABLE */
                                        }))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue"]),
                                _createElementVNode("div", _hoisted_15, [
                                  _createVNode(_component_v_tabs_window, {
                                    modelValue: tab.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tab).value = $event)),
                                    class: "h-full"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_tabs_window_item, {
                                        value: 0,
                                        class: "question-tab-content"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list, { class: "report-list" }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupQuestions.value, (item, index) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, {
                                                  key: index + 'group'
                                                }, [
                                                  _createVNode(ExamResultQuestionGroupList, {
                                                    item: item,
                                                    questionNumber: getQuestionNumber(item),
                                                    padding: true,
                                                    selected: tabSelected.value,
                                                    exam: exam.value,
                                                    "user-exam": userExam.value,
                                                    examQScoreHistory: examQScoreHistory.value
                                                  }, null, 8 /* PROPS */, ["item", "questionNumber", "selected", "exam", "user-exam", "examQScoreHistory"]),
                                                  (index + 1 < groupQuestions.value.length)
                                                    ? (_openBlock(), _createBlock(_component_v_divider, {
                                                        key: index + 'group_divider',
                                                        class: "my-0"
                                                      }))
                                                    : _createCommentVNode("v-if", true)
                                                ], 64 /* STABLE_FRAGMENT */))
                                              }), 128 /* KEYED_FRAGMENT */))
                                            ]),
                                            _: 1 /* STABLE */
                                          })
                                        ]),
                                        _: 1 /* STABLE */
                                      }),
                                      (schoolSetting.value && schoolSetting.value.useAiChatExam)
                                        ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                                            key: 0,
                                            value: 1,
                                            class: "question-tab-content"
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(), _createBlock(MesageContainer, {
                                                ref_key: "mesageContainer",
                                                ref: mesageContainer,
                                                key: tabSelected.value,
                                                targetableId: tabSelected.value,
                                                targetableType: 'Question',
                                                "using-deepseek": schoolSetting.value.usingDeepSeek,
                                                class: "h-full"
                                              }, null, 8 /* PROPS */, ["targetableId", "using-deepseek"]))
                                            ]),
                                            _: 1 /* STABLE */
                                          }))
                                        : _createCommentVNode("v-if", true),
                                      (schoolSetting.value && schoolSetting.value.useAiChatExam)
                                        ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                                            key: 1,
                                            value: 2,
                                            class: "question-tab-content"
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(), _createBlock(ThreadContainer, {
                                                key: tabSelected.value,
                                                targetableId: tabSelected.value,
                                                targetableType: 'Question',
                                                onUpdateParentTab: updateParentTab
                                              }, null, 8 /* PROPS */, ["targetableId"]))
                                            ]),
                                            _: 1 /* STABLE */
                                          }))
                                        : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["modelValue"])
                                ])
                              ])
                            ]),
                            _: 1 /* STABLE */
                          }, 512 /* NEED_PATCH */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["size"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : (mobile.value && exam.value && userExam.value?.finishedAt)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              (exam.value && exam.value.questions)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (getBanner('question_result_top'))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "banner",
                          innerHTML: getBanner('question_result_top')?.bodyHtml
                        }, null, 8 /* PROPS */, _hoisted_18))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Header giống ExamResult.vue "),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_v_btn, {
                        variant: "text",
                        class: "ps-0 ms-1 white-text",
                        onClick: backToExamResult
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { start: "" }, {
                            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                              _createTextVNode("mdi-chevron-left", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          }),
                          _cache[17] || (_cache[17] = _createElementVNode("span", null, "戻る", -1 /* CACHED */))
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(ExamGoalReturnButton, {
                        class: "ms-2",
                        "exam-id": _unref(route).params.examId as string,
                        color: "white",
                        variant: "flat"
                      }, null, 8 /* PROPS */, ["exam-id"]),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(currentGroup.value && currentGroup.value.isDescriptionQuestion
                  ? _unref($t)('exam_result.description', {
                    format: _unref(LETTER_FORMAT).UPTITLECASE
                  })
                  : `${currentIndex.value + ' ' + _unref($t)('exam_result.problem', {
                    format: _unref(LETTER_FORMAT).UPTITLECASE
                  })}`), 1 /* TEXT */),
                      _createVNode(_component_v_icon, {
                        class: "me-1",
                        color: "white",
                        onClick: toResulQuestionLList
                      }, {
                        default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                          _createTextVNode("mdi-menu", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _createVNode(_component_v_divider, { class: "m-0" }),
                    _createCommentVNode(" Question content - full width "),
                    (isShowBody.value && currentGroup.value)
                      ? _withDirectives((_openBlock(), _createBlock(_component_v_window, {
                          key: 1,
                          modelValue: mobileSwipeIndex.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((mobileSwipeIndex).value = $event)),
                          class: "my-swipe",
                          "show-arrows": false
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_window_item, {
                              value: 0,
                              class: "slide1"
                            }, {
                              default: _withCtx(() => [
                                _createCommentVNode(" Placeholder for previous question ")
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_window_item, {
                              value: 1,
                              class: "slide2"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentGroup.value.questions, (item, index) => {
                                  return (_openBlock(), _createBlock(ExamResultQuestionBodyMobile, {
                                    key: index,
                                    groupIndex: currentIndex.value,
                                    currentQuestion: item,
                                    index: index + 1,
                                    id: `question_${item.id}`,
                                    isMultipleQuestion: currentGroup.value.questions.length > 1,
                                    schoolSetting: schoolSetting.value,
                                    examQScoreHistory: examQScoreHistory.value,
                                    exam: exam.value,
                                    "user-exam": userExam.value
                                  }, null, 8 /* PROPS */, ["groupIndex", "currentQuestion", "index", "id", "isMultipleQuestion", "schoolSetting", "examQScoreHistory", "exam", "user-exam"]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_window_item, {
                              value: 2,
                              class: "slide3"
                            }, {
                              default: _withCtx(() => [
                                _createCommentVNode(" Placeholder for next question ")
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])), [
                          [_directive_touch, {
                left: () => handleSwipeLeft(),
                right: () => handleSwipeRight()
              }]
                        ])
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Footer navigation "),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_v_btn, {
                        variant: "text",
                        class: "nav-btn",
                        onClick: first,
                        disabled: isFirstItem.value
                      }, {
                        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                          _createTextVNode("最初", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["disabled"]),
                      _createVNode(_component_v_btn, {
                        variant: "text",
                        class: "nav-btn",
                        onClick: previous,
                        disabled: isFirstItem.value
                      }, {
                        default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                          _createTextVNode("前へ", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["disabled"]),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        variant: "text",
                        class: "nav-btn",
                        onClick: next,
                        disabled: isLastItem.value
                      }, {
                        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                          _createTextVNode("次へ", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["disabled"]),
                      _createVNode(_component_v_btn, {
                        variant: "text",
                        class: "nav-btn",
                        onClick: last,
                        disabled: isLastItem.value
                      }, {
                        default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                          _createTextVNode("最後", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["disabled"])
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
  ]))
}
}

})